<!-- <div class="basic-holder">
    <div class="wa-shell-loader">
        <div class="centered">
            <div id="loader-circles-holder">
                <div id="wa-inner-loader" class="obf-loading"></div>
                <div class="obf-loader-section section-left"></div>
                <div class="obf-loader-section section-right"></div>
            </div>
            <div class="obf-loading-text-container">
            </div>
        </div>
    </div>
</div> -->
<div class="default-spinner-overlay 2">
    <div class="default-spinner">
        <div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div>
    </div>
</div>
<router-outlet></router-outlet>